//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import cloneDeep from 'lodash/cloneDeep';
import moment from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import set from 'lodash/set';
import closeIcon from '@legacy/static/images/svg/close.svg';
import frag from 'vue-frag';
import {
  BLACK_FRIDAY_SLUG,
  SUMO_DAY_SLUG,
} from '@/constants/global';
import { filterAttributeDependencies, checkDependency } from '@/datalayer/helpers/attributes';
import CampaignsMixin from '~/mixins/campaigns';

moment.extend(isBetween);

export default {
  directives: { frag },
  mixins: [CampaignsMixin],
  props: {
    isSearching: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      required: true,
    },
    profileDefaults: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    aggregations: {
      type: Object,
      required: true,
    },
    mobileOpen: {
      type: Boolean,
      required: false,
      default: false,
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
    mobileResults: {
      type: Number,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      closeIcon,
    };
  },
  computed: {
    group() {
      const attribs = (
        this.isSearching ? this.aggregations?.attributes : this.$store.state.browse.attributes)
        || [];
      return attribs.find((a) => a.slug === 'group');
    },
    category() {
      const attribs = (
        this.isSearching ? this.aggregations?.attributes : this.$store.state.browse.attributes)
        || [];
      return attribs.find((a) => a.slug === 'category');
    },
    subcategory() {
      const attribs = (
        this.isSearching ? this.aggregations?.attributes : this.$store.state.browse.attributes)
        || [];
      return attribs.find((a) => a.slug === 'subcategory');
    },
    attributes() {
      /*
      let attributes = this.$store.state.browse.attributes.map((a) => ({
        attribute: a,
      }));

      attributes = attributes.filter((a) => a.attribute.can_filter === true);
      attributes = attributes.filter((a) => checkDependency(
        a.attribute.dependency, this.value.attributes,
      ));

      attributes.sort((a, b) => {
        const order = ['group', 'category', 'subcategory', 'product_type'];
        const aPos = order.indexOf(a.attribute.slug);
        const bPos = order.indexOf(b.attribute.slug);
        return aPos - bPos;
      });
      */
      const attributes = [...(this.aggregations?.attributes || [])];
      attributes.sort((a, b) => {
        if (a.doc_count === b.doc_count) {
          return a.name.localeCompare(b.name);
        }

        return b.doc_count - a.doc_count;
      });

      return attributes.filter((a) => {
        if (!checkDependency(a.dependency, this.value.attributes)) {
          return false;
        }

        return true;
      });
    },
    sortedFilters() {
      const filters = [
        {
          type: 'sort',
          priority: Number.MAX_VALUE,
        },
        {
          type: 'marketplace',
          priority: 9e3,
        },
        {
          type: 'black-friday',
          priority: 8e3,
        },
        {
          type: 'sumo-day',
          priority: 8e3,
        },
        {
          type: 'tags',
          priority: 7e3,
        },
        /*
        {
          type: 'average_rating',
          priority: 6e3,
        },
        */
        {
          type: 'plan_types',
          priority: 5e3,
        },
        {
          type: 'status',
          priority: 4e3,
        },
        {
          type: 'price_range',
          priority: 3e3,
        },
      ];

      this.attributes.forEach((attr) => {
        if (!['group', 'category', 'subcategory'].includes(attr.slug)) {
          filters.push({
            key: attr.slug,
            type: 'attribute',
            priority: attr.weight,
            attribute: attr,
          });
        }
      });

      filters.sort((a, b) => b.priority - a.priority);

      return filters;
    },
    isBlackFriday() {
      return this.isCampaignActive(BLACK_FRIDAY_SLUG);
    },
    isSumoDay() {
      return this.isCampaignActive(SUMO_DAY_SLUG);
    },
    filters() {
      const filters = [];
      const keys = this.profileDefaultKeys();

      if (!keys.includes('marketplace')) {
        const marketplace = this.aggregations?.marketplace;
        let hasSelect = true;

        if (marketplace) {
          const select = marketplace.find((a) => Number(a.key) === 0);

          if (select) {
            hasSelect = (Number(select.doc_count) > 0);
          }
        }

        if (hasSelect) {
          filters.push('marketplace');
        }
      }

      if (!keys.includes('tags')) {
        filters.push('tags');
      }

      if (!keys.includes('average_rating')) {
        filters.push('average_rating');
      }

      if (!keys.includes('type')) {
        filters.push('plan_types');
      }

      if (!keys.includes('status')) {
        filters.push('status');
      }

      if (!keys.includes('default_price')) {
        filters.push('price_range');
      }

      if (!keys.includes('bf') && this.isBlackFriday) {
        filters.push('black-friday');
      }

      if (!keys.includes('sumoday') && this.isSumoDay) {
        filters.push('sumo-day');
      }

      return filters;
    },
  },
  methods: {
    profileDefaultKeys() {
      const keys = [];

      Object.keys(this.profileDefaults).forEach((key) => {
        const index = key.indexOf('[');

        if (index > 0) {
          keys.push(key.substr(0, index));
        } else {
          keys.push(key);
        }
      });

      return keys;
    },
    change(key, value) {
      // deep clone
      const filters = cloneDeep(this.value);
      set(filters, key, value);
      this.$emit('input', filters);
    },
    changeAttr(key, value) {
      let attributes = { ...this.value.attributes };
      if (typeof value !== 'undefined') {
        attributes[key] = value;
      } else {
        delete attributes[key];
      }

      // when changing category, reset any subcategory too
      if (key === 'group') {
        delete attributes.category;
        delete attributes.subcategory;
      } else if (key === 'category') {
        delete attributes.subcategory;
      }
      attributes = filterAttributeDependencies(this.$store.state.browse.attributes, attributes);
      this.change('attributes', attributes);
    },
  },
};
